import { IDirectDebitBankDetails } from '@nx-ng/types';
import { cloneDeep } from 'lodash-es';
import { DDAccountVerifyResponse } from '../client/src';

export const mapDirectDebitBankDetails = (
  directDebitResponse: DDAccountVerifyResponse | undefined
): IDirectDebitBankDetails | undefined => {
  if (!directDebitResponse) {
    return undefined;
  }

  const { branchName, bankName, bankAddress } = directDebitResponse;

  return {
    valid: directDebitResponse.valid === 'Valid',
    branchName,
    bankName,
    bankAddress: cloneDeep(bankAddress),
  };
};
